import { createFileRoute, redirect } from "@tanstack/react-router";

import { hasPermission } from "@/modules/auth/lib/permissions";
import { MaterialRequestsPage } from "@/modules/material/pages/MaterialRequests.page";

export const Route = createFileRoute("/__authed/m/materials/requests")({
	beforeLoad({ context }) {
		const user = "user" in context ? context.user : undefined;

		if (!hasPermission(user, "see_material_requests")) {
			throw redirect({ to: "/m/dashboard" });
		}
	},
	component: MaterialRequestsPage,
});
